import * as React from 'react';
import Close from '@mui/icons-material/Close';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { Theme, useTheme } from '@mui/material/styles';
import { observer } from 'mobx-react';

import { DefaultAppProps } from '../App';

import { ios, android } from '@egr/xbox/utils/UserAgent';
import { makeStyles, MakeStylesHook } from '@egr/xbox/utils/tss-react';

type GuideClassKey = 'close' | 'img';

const useGuideStyles: MakeStylesHook<GuideClassKey> = makeStyles({ name: 'Guide' })({
    close: {
        position: 'relative',
        top: -2,
        left: -12,
    },
    img: {
        maxWidth: '100%',
    },
});

export const Guide: React.FC<DefaultAppProps> = observer((props) => {
    const { classes } = useGuideStyles();

    const theme: Theme = useTheme();

    const handleClose: () => void = () => {
        props.app.viewManager.showGuide(false);
    };

    let title: string = 'Keyboard and Mouse Controls';
    let img: React.ReactNode = <img className={classes.img} src="./img/guide_desktop.png" />;

    if (ios || android) {
        title = 'Touch Controls';
        img = <img className={classes.img} srcSet="./img/guide_mobile.png, ./img/guide_mobile_2x.png 2x" src="./img/guide_mobile.png" />;
    } else if (props.app.viewManager.state.keyboardLayout === 'fr') {
        img = <img className={classes.img} src="./img/guide_desktop_fr.png" />;
    }

    return (
        <Dialog
            style={{ zIndex: theme.zIndex.modal + 1 }}
            open={props.app.viewManager.state.showGuide}
            onClose={handleClose}
            onBackdropClick={handleClose}
            maxWidth={false}
        >
            <DialogTitle>
                <IconButton className={classes.close} onClick={handleClose}>
                    <Close />
                </IconButton>
                {title}
            </DialogTitle>
            <DialogContent>{img}</DialogContent>
        </Dialog>
    );
});